export default "__VITE_ASSET__BlWqZCIX__"